module.exports = __webpack_public_path__ + "ceca6c481f96ff5740c0c6c243f4405f.svg";